import React from 'react'
import axios from 'axios'
import { Layout, Modal, Row, Col, Descriptions, Tabs, Button, Divider, Statistic, Form, Input, InputNumber, Space, message, Alert, Spin, Select, Table, Dropdown, Menu } from 'antd';
import MaoliangEdit from 'containers/member/maoliangEdit';
import MemberPwdEdit from 'containers/member/memberPwdEdit';
import { layout, tailLayout } from 'containers/common/layout';
import '../../form.css';

import {
    UserOutlined,
    EditOutlined,
    GoldOutlined,
    EyeOutlined,
    ReloadOutlined,
    DownOutlined,
    UnorderedListOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Content } = Layout;
const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

class MemberDemo extends React.Component {

    constructor(props: any) {
        super(props);
        this.getOrders();
    }

    state = {
        memberOrders: [],
        memberDetail: [],
        total: 0,
        loading: true,
        orderLoading: true,
        pwdEditorVisible: false,
        pwdEditorTitle: '重置密码',
        maoliangEditorVisible: false,
        maoliangEditorTitle: '赠送猫粮',
        dataId: 0,
    };

    columns = [
        {
            title: '订单编号',
            dataIndex: 'orderId',
            width: '8%'
        },
        {
            title: '预订行程',
            dataIndex: 'tripName',
            width: '20%'
        },
        {
            title: '订单状态',
            dataIndex: 'status',
        },
        {
            title: '下单时间',
            dataIndex: 'orderTime',
        },
        {
            title: '操作',
            dataIndex: 'userId',
            render: (text: React.ReactNode) => <Link to={{ pathname: `members/detail/${text}` }} target="_blank"><Button shape="round" key={`a-${text}`}><EyeOutlined />查看</Button></Link>,
        }
    ];

    getImage = () => {
        let data = {
            'title': '【5折爆款】半山云水2店大促，周末不加价！爆款悬浮浴缸+天空之镜+无边泳池，赠高铁站单次接送',
            'image': 'http://static.cattour.cn/ff26c5c4e2c4304adab1efe8c7f8c50a.jpg',
            'price': 888,
            'page': 'packageProducts/pages/products/detail/daytrip/index',
            "scene": "saleId:139,productType:DDWL",
        };
        axios({
            method: "post",
            url: "http://share-api.lanmao.cn/share/get_share_image?token=mVnCvml6Dovrnms7PmsaDvvIw&dev=True",
            data
        })
            .then((res) => {
                console.log('res image', res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getOrders = () => {
        this.setState({
            orderLoading: true
        });
        let data = { "saleId": 136, "productType": "DDWL" };
        axios({
            method: "post",
            url: "/wx/product/productDetail",
            data
        })
            .then((res) => {
                console.log('res orders', res.data.data)
                this.setState({
                    memberOrders: res.data.data,
                    orderLoading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // 打开 Modal
    showModal = (name: string) => {
        if (name == 'maoliangEditorVisible') {
            this.setState({
                maoliangEditorVisible: true
            })
        } else if (name == 'pwdEditorVisible') {
            this.setState({
                pwdEditorVisible: true
            })
        }
    };

    // 关闭 Modal
    cancelModal = (name: string) => {
        if (name == 'maoliangEditorVisible') {
            this.setState({
                maoliangEditorVisible: false
            })
        } else if (name == 'pwdEditorVisible') {
            this.setState({
                pwdEditorVisible: false
            })
        }
    };

    // 提交表单
    onFinish = (values: any) => {
        message.info("提交了表单: " + JSON.stringify(values));
        console.log('values', values);
    };

    // 切换Tab
    onTabsClick = (value: any) => {
        if (value == 'orders') {
            console.log('tabs', value);
            this.getOrders();
        }
    }

    onChange = (value: any) => {
        console.log('value', value);
        this.showModal(value.key);
    }

    render() {
        let detail: any = this.state.memberDetail;
        console.log('detail', detail);

        return (
            <div>
                <Content
                    style={{
                        padding: 24,
                        background: '#eee',
                        minHeight: 680,
                        width: 640
                    }}
                >

                </Content>
            </div>
        )
    }
}

export default MemberDemo;